import React, { useEffect, useState } from 'react'
import { Modal, notification } from 'antd';
import { useFormik } from 'formik';
import * as yup from 'yup';
import axiosInstance from '../../../../Services/axiosCommon';
import Attachement from '../../../../Components/Utils/CustomAttrachmentupload';
import { useToast } from '../../../../Components/Others/ToastServices';
import { SettingHeading } from '../../../../Components/Utils/Settingheading';
import { NuInput } from '../../../../Components/Utils/Input';
import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import { useParams } from 'react-router-dom';

const CreateEquipmentEqu = ({ open, getData, onCancel, data }) => {
  const [api, contextHolder] = notification.useNotification();
  const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState([]);
  const toast = useToast();
  const {id} = useParams()
 const { value: type,getData:reftype } = useFetchMataData(
        `/dropdown/dropdown-details/`,
        "type_equipments"
      );
  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    let tempArr = [];
    setSelectedFile(fileArr);

    fileArr.forEach((item) => {
      tempArr.push(item?.name);
    });

    setImage(tempArr);
    e.target.value = null; // reset
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value);
    setSelectedFile([...List]);
    let tempArr = [];
    List.forEach((item) => tempArr.push(item?.name));
    setImage(tempArr);
  };

  // Pre-fill form if editing
  const [createNew, setCreateNew] = useState({
    idNumber: "",
    type: "",
    location: "",
    qrCode: "",
    equipmentId:id
  });

  useEffect(() => {
    if (data) {
      setCreateNew({
        idNumber: data.idNumber || "",
        type: data.type || "",
        location: data.location || "",
        qrCode: data.qrCode || ""
      });
    }
  }, [data]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      idNumber: yup.string().required("ID Number is required"),
      type: yup.string().required("Type is required"),
      location: yup.string().required("Location is required"),
      qrCode: yup.string().required("QR Code is required")
    }),
    onSubmit: (value, { resetForm }) => {
      // let formData = new FormData();
      // formData.append("json_data", JSON.stringify(value));

      // if (selectedFile !== null) {
      //   selectedFile.forEach((file) => {
      //     formData.append("attachments", file);
      //   });
      // } else {
      //   formData.append("attachments", []);
      // }

      axiosInstance
        .post("/equipment-details/create", value, resetForm)
        .then((res) => {
          if (res.status === 201 || res.data.status === true) {
            getData();
            resetForm();
            api.success({
              message: `Equipment created successfully`,
              description: res?.data?.msg || "Equipment added",
              placement: "bottomRight",
            });
            onCancel();
          } else {
            api.error({
              message: `Equipment creation failed`,
              description: res?.data?.msg || "Network error",
              placement: "bottomRight",
            });
          }
        })
        .catch((err) => {
          api.error({
            message: `Equipment creation failed`,
            description: err?.data?.msg || "Server error or Network error",
            placement: "bottomRight",
          });
        });
    },
  });

  return (
    <>
      {contextHolder}
      <Modal
  open={open}
  title={data ? "Edit Equipment" : "Create Equipment"}
  centered
  onCancel={onCancel}
  footer={null}
  className="perfect-centered-modal"
  styles={{
    body: {
      maxHeight: "75vh",
      overflowY: "auto",
      padding: "12px",
    },
  }}
  width="75%" // ✅ Full width on small devices
>
  <form onSubmit={formik.handleSubmit}>
    <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4">
      {/* ID Number */}
      <NuInput
        label="ID Number"
        placeholder="Enter ID Number"
        formik={formik}
        name="idNumber"
        width="w-full"
      />

      {/* Type Dropdown */}
      <DropDownAddMetaData
        label="Type"
        placeholder="Choose"
        Options={type}
        formik={formik}
        name="type"
        width="w-full"
        getFunc={reftype}
        displayProperty={"Type"}
        propertyName={"type_equipments"}
        FixPosition={false}
        PortalTarget={false}
        isRequired={true}
      />

      {/* Location */}
      <NuInput
        label="Location"
        placeholder="Enter Location"
        formik={formik}
        name="location"
        width="w-full"
      />

      {/* QR Code */}
      <NuInput
        label="QR Code"
        placeholder="Enter QR Code"
        formik={formik}
        name="qrCode"
        width="w-full"
      />
    </div>

    {/* Attachments (optional) */}
    {/* <div className="w-full mt-4">
      <SettingHeading title="Attachments :" />
      <Attachement
        handleChange={handleImageChange}
        preview={image || ""}
        width="w-full"
        label="Attach"
        multiple={true}
        removeImages={removeImages}
      />
    </div> */}

    {/* Submit Button */}
    <div className="mt-6 flex justify-center">
      <button
        type="submit"
        className="w-full sm:w-1/2 lg:w-1/3 bg-textColor-main py-3 rounded-lg text-sm text-white hover:opacity-90 transition"
      >
        {data ? "Update" : "Create"}
      </button>
    </div>
  </form>
</Modal>

    </>
  );
};

export default CreateEquipmentEqu;
